import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { languages } from '../../helpers/language-helpers';
import { AuthService } from '../../../auth/services/auth.service';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-language-select',
  templateUrl: './language-select.component.html',
  styleUrl: './language-select.component.scss',
})
export class LanguageSelectComponent implements OnInit {
  languages = languages;
  isAuthenticated: Observable<boolean>;

  constructor(
    public languageService: LanguageService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.isAuthenticated = this.authService.isAuthenticated();
  }

  setLanguage(event: any) {
    this.languageService.setLanguage(event.target.value).subscribe();
  }
}
